var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('img',{staticClass:"loading",attrs:{"src":_vm.getGifUrl(),"alt":"loading"}}),_c('p',{staticClass:"loading__text"},[_vm._v("loading ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }